import React, { useEffect, useRef } from 'react';

const FindOurSchool = () => {
  const mapRef = useRef(null);

  useEffect(() => {
    if (window.google && mapRef.current) {
      const map = new window.google.maps.Map(mapRef.current, {
        center: { lat: 28.0186, lng: -82.1284 }, // Plant City, FL coordinates
        zoom: 15,
      });

      new window.google.maps.Marker({
        position: { lat: 28.0186, lng: -82.1284 },
        map: map,
        title: 'Kids Club Early Learning Center LLC',
      });
    }
  }, []);

  return (
    <div className="find-our-school">
      <div className="container">
        <h1>Find Our School</h1>
        
        <div className="school-info">
          <div className="address-section">
            <h2>Location</h2>
            <div className="address">
              <h3>Kids Club Early Learning Center LLC</h3>
              <p>608 N Alexander St</p>
              <p>Plant City, FL 33563</p>
              <p>Phone: 813-752-6446</p>
            </div>
            
            <div className="directions">
              <h3>Directions</h3>
              <p>We're conveniently located in the heart of Plant City, easily accessible from major roads and highways.</p>
              <a 
                href="https://maps.google.com/?q=Kids+Club+Early+Learning+Center+LLC+Plant+City+FL" 
                target="_blank" 
                rel="noopener noreferrer"
                className="btn btn-primary"
              >
                Get Directions
              </a>
            </div>
          </div>
          
          <div className="map-section">
            <div ref={mapRef} className="map-container"></div>
          </div>
        </div>
        
        <div className="hours-section">
          <h2>Hours of Operation</h2>
          <div className="hours">
            <p><strong>Monday - Friday:</strong> 6:30 AM - 6:00 PM</p>
            <p><strong>Saturday:</strong> Closed</p>
            <p><strong>Sunday:</strong> Closed</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FindOurSchool;